import { render, staticRenderFns } from "./ordering.vue?vue&type=template&id=575b99fb&scoped=true"
import script from "./ordering.vue?vue&type=script&lang=js"
export * from "./ordering.vue?vue&type=script&lang=js"
import style0 from "./ordering.vue?vue&type=style&index=0&id=575b99fb&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "575b99fb",
  null
  
)

export default component.exports